import React from 'react'
// redux
// components
// types
import { Classes } from 'jss'
// styles
import injectSheet from 'react-jss'
import { sheet } from './sheet'
// utils
import ContentCard from 'components/layouts/ContentCard'
import Modal, { ModalProps } from 'components/Modal'
import { sheet as ModalSheet } from 'components/Modal/sheet'
import { Divider } from 'components/ui/Divider'
import { Button } from 'components/ui/Button'

export interface ModalDialogProps extends ModalProps {
  buttonType?: 'approve' | 'warning'
  buttenText?: string
  cancelText?: string
  onApprove?: () => void
  onDelete?: () => void
  approveDisabled?: boolean
  // open: boolean
  // onClose: () => void
  // title?: string
  // children?: React.ReactNode
  // classes: Classes
}

const ModalDialog = ({
  classes,
  open,
  onClose,
  title,
  children,
  width = 400,
  buttonType = 'approve',
  buttenText = 'Okay',
  cancelText = 'Cancel',
  onApprove,
  onDelete,
  approveDisabled = false,
  closeOnOverlayClick = false
}: ModalDialogProps) => {
  if (!open) return null

  const handleOverlayClick = () => {
    if (!closeOnOverlayClick) return
    onClose()
  }

  return (
    <div style={{ zIndex: 9999 }} className={classes.overlay} onClick={handleOverlayClick}>
      <ContentCard style={{ width }} padding="none" onClick={e => e.stopPropagation()}>
        <div className={classes.header}>
          <h4 style={{ margin: 0 }}>{title}</h4>
        </div>
        <div className={classes.textWrapper}>{children}</div>
        <Divider />
        <div
          className={`d-flex ${classes.btnWrapper}`}
          style={{ justifyContent: onDelete ? 'space-between' : 'flex-end' }}
        >
          {onDelete && <Button label="Delete" color="danger" onClick={onDelete} />}
          <div className={classes.btnRight}>
            <Button label={cancelText} variant="outlined" onClick={onClose} />
            {onApprove && (
              <Button
                label={buttenText}
                color={buttonType === 'warning' ? 'danger' : 'primary'}
                onClick={onApprove}
                disabled={approveDisabled}
              />
            )}
          </div>
        </div>
      </ContentCard>
    </div>
  )
}

export default injectSheet({
  ...sheet,
  overlay: ModalSheet.overlay,
  closeBtn: ModalSheet.closeBtn
})(ModalDialog)
